import { FacebookActionTypes } from "./FacebookActionTypes";

export const errorSyncingAdSets = (err: Error) =>
  ({
    type: FacebookActionTypes.FACEBOOK_ERROR_SYNCING_AD_SETS,
    err,
  } as const);
